import App, {IS_DEVELOPMENT} from './App';
import Signup from './Signup';
import {getLocaleFromUrl} from './Signup/utils';
import XeroSignup from './XeroSignup';
import {Translate} from '@planday-corp/globalization';
import {renderApp} from '@planday-corp/react-app';
import React, {Suspense} from 'react';
import {Outlet, Route, Routes} from 'react-router-dom';
import DevMenu, {DevApp} from '~/shared/components/DevMenu';

const APPS: DevApp[] = [
  {
    title: `Xero Signup  -> instructions in README.md`,
    appName: 'signup/xero',
    path: '/',
    queryString:
      '?signupRequestId={paste_your_request_id}&SignupSource=Xero&SignupOrigin=None',
    component: <XeroSignup />,
  },
  {
    title: 'Planday Signup (default)',
    appName: 'signup/default',
    path: 'planday-signup/*',
    component: <Signup />,
  },
];

renderApp(
  <App enforcedLanguage={getLocaleFromUrl()}>
    <Routes>
      <Route
        path="/"
        element={
          <>
            {IS_DEVELOPMENT && <DevMenu apps={APPS} />}
            <Suspense
              fallback={
                <Translate
                  term="CommonTerms.LoadingPleaseWait"
                  fallback="Loading..."
                />
              }
            >
              <Outlet />
            </Suspense>
          </>
        }
      >
        {APPS.map(app => (
          <Route
            key={app.appName}
            path={`${app.path}`}
            element={app.component}
          />
        ))}
      </Route>
    </Routes>
  </App>,
  '#root',
  'signup/index'
);
